import { supportedLngs, useTransl } from 'shared/lib/i18n';

import { TermsAndConditionsEn } from './TermsAndConditionsEn';
import { TermsAndConditionsFr } from './TermsAndConditionsFr';

const TermsAndConditions = () => {
  const { i18n } = useTransl();
  return i18n.language === supportedLngs.fr ? (
    <TermsAndConditionsFr />
  ) : (
    <TermsAndConditionsEn />
  );
};

export default TermsAndConditions;
